import React, { Component } from 'react';
import './../css/master.css';
import './../css/availability.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
//import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
var httpURL = '';
var queryString = require('querystring');
var lstMonthSpan=[];
var machineIdCol 		= 'td:eq(0)';
var machineTypeCol 		= 'td:eq(1)';
var machineCapacityCol 	= 'td:eq(2)';
var machineCountCol 	= 'td:eq(3)';
var mId='';
var url = '';
var lstAvailability=[];
class ShowAvailability extends Component {
  constructor(props){
	super(props);
	this.state={
		availability:[],
		lstAvailability:[],
		minDate:new Date(),
		maxDate:null,
		machineId:'',
		endDate:null,
		startDate:null,
		width:'97.6%',
  }
	this.handleChange = this.handleChange.bind(this);
	this.handleChange1 = this.handleChange1.bind(this);
  }
  
  handleChange(date){
    this.setState({
      startDate: date,
    });
  }
  handleChange1(date){
    this.setState({
      endDate: date
    });
  }
  
  
  async componentDidMount(){
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
		 
		var date =  new Date();
	 	date.setMonth(date.getMonth()+1);
		var startDate = date;
		await this.setState({
		 startDate:new Date(startDate),
		});
		var endDate = new Date(date);
	 	endDate.setDate( endDate.getDate()+89);
		await this.setState({
			endDate:new Date(endDate),
		});
		
		const height = $('#typeTable thead').height();
		$('#availabilityTable thead').css('height',height+' !important');
		this.getAvailability();
 }
	
 handleResize=()=>{
	var width = ($('.availabilityTableDiv').width())-17;
	this.setState({width:width})
}
  getAvailability =()=> {
		var fromDate = $('#inp_fromDate').val();
		var toDate = $('#inp_toDate').val();
		var url_string = window.location.href;
		url = new URL(url_string);
		if(url.searchParams.get("lstWeaver") == null){
			var lstWeaver = null;
		}else{
			var lstWeaver =  url.searchParams.get("lstWeaver").split(',');
		}
		var weaver = {'weaverId':lstWeaver, 'startDt':fromDate, 'endDt':toDate};
	
		axiosInstance.post(httpURL+'/a/mst/availability/list', 
			queryString.stringify({'weaver':JSON.stringify(weaver)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
					lstAvailability=response.data.lstAvailability;
					lstMonthSpan=response.data.lstMonthSpan;
					this.setAvailabilityTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
				}
			}
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
 }
 
 setAvailabilityTable =()=> {
	$('#availabilityTableBody tr').remove();
	$('#availabilityThead').empty();
	var theadDiv  = $('#availabilityThead');
	var row3 = document.createElement('tr');
	var row2 = document.createElement('tr');
	var table  =  document.createElement('table');
	var thead  =  document.createElement('thead');
	
	for(var z=0; z<lstMonthSpan.length; z++){
		var month = lstMonthSpan[z].month;
		var span = lstMonthSpan[z].spanCols;
    var maxD =lstMonthSpan.spanCols;
	  this.addTH2(row3,lstMonthSpan[z].spanCols+lstMonthSpan[z].startDay-1,lstMonthSpan[z].startDay);
		this.addTH(row2, span, month);
	}
	thead.append(row2);
	thead.append(row3);
	table.append(thead);
	theadDiv.append(table);

	$('#typeTableBody tr').remove();
		var typeTable 			= document.getElementById('typeTable');
		var typeTbody 			= document.getElementById('typeTableBody');
		var availabilityTable 	= document.getElementById('availabilityTable');
		var availabilityTbody 	= document.getElementById('availabilityTableBody');
		
		for(var k=0; k<lstAvailability.length; k++){
				var weaverId	    = lstAvailability[k].weaverId;    
	    	var weaver		    = lstAvailability[k].weaver;
		    var lstMachine   	= lstAvailability[k].lstAvailability;
		   
    		for(var j=0; j<lstMachine.length; j++){
	        var row = document.createElement('tr');
			    row.className = weaverId;
		     	if(j==0){
			    	this.addTDSpan(row, weaver, '', lstMachine.length);
    			}	
					var row1 = document.createElement('tr');
		      var availability	= lstMachine[j].availability;
					
					for(var i=0; i<availability.length; i++){
          	this.addTD1(row1, availability[i],lstMachine[j].count, '');
			    	availabilityTbody.append(row1);
					}
					
					this.addTD(row, lstMachine[j].mty, '');
		      this.addTD(row,  lstMachine[j].capacity, 'txtright');
					this.addTD(row,  lstMachine[j].count, 'txtright');
					
					typeTbody.append(row);
		      availabilityTable.append(availabilityTbody);
	    	}
		}
		typeTable.append(typeTbody);
	}

	addTDSpan(row, val, classname, span){
		var cell = document.createElement('td');
		cell.rowSpan = span;
		var text = document.createTextNode(val);
		cell.className = classname ;
		cell.append(text);
	  row.append(cell);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	addTD1(row, val, count, classname){
		var cell = document.createElement('td');
		if(val == count){
			cell.style.backgroundColor = 'rgb(223, 253, 172)';
		  cell.className += classname;
		  cell.colSpan=2;
		  row.append(cell);
		}else if(val == 0){
			cell.style.backgroundColor = '#ddd';
			cell.className += classname;
	    cell.colSpan=2;
	    var icon = document.createElement('span');
		  icon.className="glyphicon glyphicon-remove text-muted";
		  cell.append(icon);
      row.append(cell);
		}else{
		  cell.style.backgroundColor = '#fff';
			cell.className += classname;
		  cell.colSpan=2;
		  var text = document.createTextNode(val);
		  cell.append(text);
		  row.append(cell);
		}
	}
	
	addTH(row, span, val){
		var cell = document.createElement('th');
		cell.style.textAlign='center';
		cell.colSpan = span*2;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	addTH2(row, maxdate,startdate){
		for(var m=startdate;m<=maxdate; m++){
			var cell = document.createElement('th');
			cell.style.width='20px';
			var text = document.createTextNode(m);
			cell.colSpan = 2;
			cell.append(m);
			row.append(cell)
		}
	}

	theadScroll=(e)=>{
		$('#availabilityThead').prop('scrollLeft', e.target.scrollLeft);
		$('.availabilityTableDiv1').prop('scrollTop', e.target.scrollTop);
	}

  render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div className="main">
				<div className="container-fluid">
					<div className="col-sm-12 col-centered">
						<div className="col-sm-6 col-centered"  style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', marginBottom:10}}>
							<div style={{flex:1}} className="text-center">
								<label htmlFor="inp_fromDate">From Date</label>
							</div>
							<div style={{flex:2}} className="text-center">
								<DatePicker id="inp_fromDate"
									className='form-control'
									placeholderText="From Date"
									selected={this.state.startDate}
									onChange={this.handleChange}
									dateFormat="dd-MM-yyyy"
									minDate= {this.state.minDate}
									autoComplete='off'
								/>
							</div>
							<div style={{flex:1}} className="text-center">
								<label htmlFor="inp_toDate">To Date</label>
							</div>
							<div style={{flex:2}} className="text-center">
								<DatePicker id="inp_toDate"
									className='form-control'
									placeholderText="To Date"
									selected={this.state.endDate}
									onChange={this.handleChange1}
									dateFormat="dd-MM-yyyy"
									minDate= {this.state.startDate}
									maxDate= {this.state.maxDate}
									autoComplete='off'
								/>
							</div>
							<div className="pull-right">
								<button style={{marginRight:20,marginLeft:20}} type="button" className="btn btn-warning" onClick={this.getAvailability} id="availability">Availability</button>
							</div>
						</div>
						<div className="row">
							<div style ={{width:'31%'}} className="col-sm-3 col-xs-3 padding-remove">
								<table className="tableLayout">
									<thead>
										<tr>
											<th style={{width:50,display:'none'}}>Weaver Id</th>
											<th style={{width:50}}>Weaver</th>
											<th style={{width:50,display:'none'}}>Machine Id</th>
											<th style={{width:120,height:44}}>Machine Type</th>
											<th style={{width:40}}>Capacity</th>
											<th style={{width:30}}>Count</th>
										</tr>
									</thead>
								</table>
								<div className="availabilityTableDiv1">
									<table id="typeTable" className="tableLayout">
											<colgroup>
												<col style={{width:50}} />
												<col style={{width:120}} />
												<col style={{width:40}} />
												<col style={{width:30}} />
											</colgroup>
											<tbody id="typeTableBody"> 
											</tbody>
										</table>
								</div>
							</div>
							<div className="col-sm-9 col-xs-9 padding-remove" style={{width:'69%'}}>
								<div id="availabilityThead" style={{width:this.state.width}}></div>
								<div className="availabilityTableDiv" onScroll={this.theadScroll} style={{height:400, overflowY:'scroll'}}>
									<table id="availabilityTable">
										<tbody id="availabilityTableBody">
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default ShowAvailability;
